export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, DirectoriesResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    onPremisesFormSaved() {
        return this.$state.reload('company.directory-integration');
    }

    showDeactivateAgentModal() {
        this.$uibModal
            .open({
                component: 'companyDirectoryIntegrationManageConnectionDeactivateAgent',
                resolve: {
                    companyId: () => this.companyId,
                    directoryId: () => this.directory.id,
                },
            }).result
            .then((directory) => {
                Object.assign(this.directory, directory);
                this.Alert('success', 'company.directory-integration.manage.connection.deactivate-agent.deactivated');
            })
    }

    showDownloadAgentModal() {
        this.$uibModal
            .open({
                component: 'companyDirectoryIntegrationManageConnectionDownloadAgent',
                resolve: {
                    companyId: () => this.companyId,
                    directoryId: () => this.directory.id,
                },
            }).result
            .then((directory) => {
                Object.assign(this.directory, directory);
                this.Alert('success', 'company.directory-integration.manage.connection.deactivate-agent.deactivated');
            })
    }

    updateActiveDirectoryActivationCode() {
        this.isUpdating = true;
        this.DirectoriesResource
            .updateActiveDirectoryActivationCode(this.companyId, this.directory.id)
            .then((directory) => Object.assign(this.directory, directory))
            .then(() => this.Alert('success', 'company.directory-integration.manage.connection.activation-code-updated'))
            .finally(() => this.isUpdating = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/directory-manage-connection.controller.js